<template>
  <div class="superContract-partnerManage-page">
    <p class="hasBottomLine">币种管理</p>
    <div class="header-seach-box">
      <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')">添加交易币种</el-button>
    </div>

    <div class="table-box">
      <el-table :data="generalListInfo" border style="width: 99.9%">
        <el-table-column prop="id" label="ID" width="80"> </el-table-column>
        <el-table-column prop="coinType" label="币种"> </el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == true">上架</span>
            <span v-else style="color:red">下架</span>

            <el-button @click="popconfirm(scope.row.id, scope.row.status)"
              ><label v-if="scope.row.status == true">下架</label> <label v-else>上架</label></el-button
            >
          </template>
        </el-table-column>

        <el-table-column prop="status" label="是否可以交易" width="120">
          <template slot-scope="scope">
            <strong class="greyCol"><span v-if="scope.row.canOpen == true">可交易</span> <span v-else>不可交易</span></strong>
            <el-button @click="popconfirm2(scope.row.id, scope.row.canOpen)"
              ><label v-if="scope.row.canOpen == true">禁用</label> <label v-else>启用</label></el-button
            >
          </template>
        </el-table-column>

        <el-table-column prop="tradeTime" label="交易时间">
          <template slot-scope="scope">
            <span> {{ scope.row.tradeTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="开户时间">
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="updateTime" label="最新维护时间">
          <template slot-scope="scope">
            <span> {{ scope.row.updateTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="" label="支持指数标的">
          <template slot-scope="scope">
            <div class="indexCoinClome" v-for="(item, index) in scope.row.indexList" :key="item.indexCoin + index">
              <strong :class="item.status == true ? '' : 'greyCol'"
                >{{ item.indexCoin }} <span v-if="item.status == true">上架中</span> <span v-else>已下架</span></strong
              >
              <el-button type="text" @click="putawayIndexCoin(item.id, item.status)"
                ><label v-if="item.status == true">下架</label> <label v-else>上架</label></el-button
              >
              <el-button type="text" @click="getIndexCoinFeeRate(item.id)" >
                <label>修改费率</label>
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="maxDay" label="操作" width="340">
          <template slot-scope="scope">
            <el-button type="primary" @click="editBtn(scope.row, 'edit')">管理币种</el-button>
            <el-button type="primary" @click="toGoManage2(scope.row)">管理项目方</el-button>
            <el-button type="primary" style="margin-top:12px" @click="addSupportCoin(scope.row)">添加支持指数标的</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
   
    <!---dialog--->
    <el-dialog title="项目方币种上下架开关" class="bk-ui5-dialog" :visible.sync="upOrDownDialog">
      <p class="descText" v-if="editInfo.status == true">
        是否下架该合作方：<span style="color:red">{{ editInfo.userId }} </span>
      </p>
      <p v-else>确认上架？</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upOrDownDialog = false">取 消</el-button>
        <el-button type="primary" @click="upOrDownSwitchBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitleText" class="bk-ui5-dialog" :visible.sync="editDialog">
      <!-- <p>{{ editInfo }}</p> -->
      <el-form ref="form" :model="updateInfo" label-width="150px">
        <el-form-item label="币种">
          <el-input v-model="updateInfo.coinType"></el-input>
        </el-form-item>

        <el-form-item style="margin-top:40px" label="最小单笔交易额">
          <el-input v-model="updateInfo.minAmount"></el-input>
        </el-form-item>
        <el-form-item label="最大单笔交易额">
          <el-input v-model="updateInfo.maxAmount"></el-input>
        </el-form-item>
        <el-form-item label="单客户单边最大持仓">
          <el-input v-model="updateInfo.userPositionLimit"></el-input>
        </el-form-item>

        <el-form-item label="分润佣金比率">
          <el-input v-model="updateInfo.profitCommission" placeholder="请输入小数如：（0.35）"></el-input>
        </el-form-item>
        <el-form-item label="邀请返佣（一级）">
          <el-input v-model="updateInfo.firstBonus" placeholder="请输入小数如：（0.35） --非必填"></el-input>
        </el-form-item>
        <el-form-item label="邀请返佣（二级）">
          <el-input v-model="updateInfo.secondBonus" placeholder="请输入小数如：（0.35）--非必填"></el-input>
        </el-form-item>

        <el-form-item label-width="180px" label="代理商邀请返佣（一级）">
          <el-input v-model="updateInfo.agentFirstBonus" placeholder="请输入小数如：（0.35） --非必填"></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="代理商邀请返佣（二级）">
          <el-input v-model="updateInfo.agentSecondBonus" placeholder="请输入小数如：（0.35）--非必填"></el-input>
        </el-form-item>

        <el-form-item label="平仓线（保证金剩余）" class="setSmallInput">
          <el-input v-model="updateInfo.stopMarginRatio"></el-input>
          <div class="divText">≥ 平仓线 ≥</div>
          <el-input v-model="updateInfo.blastMarginRatio"></el-input>
        </el-form-item>

        <p style="padding-left:200px">支持1-100内任意范围证书杠杆倍数开仓</p>
        <el-form-item label="杠杆倍数" class="setSmallInput">
          <el-input v-model="marginFold[0]" type="number">
            <template slot="append"
              >X</template
            >
          </el-input>
          <span style="padding-right:12px"> ~ </span>
          <el-input v-model="marginFold[1]">
            <template slot="append"
              >X</template
            >
          </el-input>
          
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="updateInfo.sort" type="number" placeholder="数值越大排序越靠前"></el-input>
        </el-form-item>

        <el-form-item label="开启交易时间">
          <el-date-picker v-model="updateInfo.tradeTime" value-format="timestamp" type="datetime" placeholder="开启交易时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" v-if="diaStatus == 'edit'" @click="editCommitBtn()">提 交</el-button>
        <el-button type="primary" v-if="diaStatus == 'add'" @click="addCommitBtn()">新 增</el-button>
      </div>
    </el-dialog>
    <!--指数dialog-->
    <el-dialog title="选择添加支持指数标的" class="bk-ui5-dialog" :visible.sync="supportDialog">
      <el-form ref="form" :model="addCoinValue" label-width="150px">
        <el-form-item label-width="180px" label="指数币种">
          <el-select v-model="addCoinValue.indexCoin" placeholder="请选择">
            <el-option v-for="(item, index) in supportCoinArr" :key="index" :label="item" :value="item" :disabled="item == '上海'">
            </el-option>
          </el-select>
       </el-form-item>
        <el-form-item label-width="180px" label="开仓手续费">
          <el-input v-model="addCoinValue.openFeeRate" placeholder="请输入小数如：（0.0005)"></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="持仓手续费">
          <el-input v-model="addCoinValue.positionFeeRate" placeholder="请输入小数如：（0.0005)"></el-input>
        </el-form-item>
        <el-form-item label-width="180px" label="平仓手续费">
          <el-input v-model="addCoinValue.closeFeeRate" placeholder="请输入小数如：（0.0005)"></el-input>
        </el-form-item>
      </el-form>  
      <div slot="footer" class="dialog-footer">
        <el-button @click="supportDialog = false">取 消</el-button>
        <el-button type="primary" v-if="diaIndexStatus == 'edit'" @click="editsupportCommitBtn()">提 交</el-button>
        <el-button type="primary" v-if="diaIndexStatus == 'add'" @click="supportCommitBtn()">新 增</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "partnerManage",
  data() {
    return {
      visible2: false,
      supportCoinArr: [],
      addCoinValue: {},

      editDialog: false,
      dialogTitleText: "",
      diaStatus: "edit",
      diaIndexStatus: "edit",
      upOrDownDialog: false,
      value: "",
      editInfo: {},
      selectType: "0",
      serchInfo: {
        selectType: "1", //0全部  1 抵押币种 2借贷币种
        selectCoin: "",
        statusType: "0" //0 全部  1停用 2启用
      },
      supportDialog: false,
      currentPage: 1,
      pageSize: 10,

      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      updateInfo: {
        status: false
      },
      marginFold: []
    };
  },
  computed: {
    ...mapState("FinanceManage", ["generalListInfo", "generalListTotal"])
  },
  methods: {
    ...mapActions("FinanceManage", ["getGeneralList"]),
    hanldSelectType() {
      this.serchInfo.selectCoin = "";
    },
    sizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange(val) {
      console.log(`当前页: ${val}`);
      this.getPageListInfo();
    },

    getPageListInfo() {
      let postData = {
        page: this.currentPage,
        size: this.pageSize
      };

      this.getGeneralList(postData);
    },

    handleSearch() {},
    showDialog(n) {
      this.dialogArr[n] = true;
    },
    handleOpenSwitch(openStatus) {
      this.dialogArr.openSwitchDialog = true;
      return false;
    },
    clearForm() {
      this.editDialog = false;
      this.upOrDownDialog = false;
      this.supportDialog = false;
      this.addCoinValue = {};
    },

    preceptStatus(row, status, index) {
      this.upOrDownDialog = true;
      this.editInfo = JSON.parse(JSON.stringify(row));
      this.editInfo.indexNum = index;
    },

    //上架或下架 按钮
    upOrDownSwitchBtn() {
      let that = this;
      api
        .generalUpOrDown({
          id: that.editInfo.id,
          status: !that.editInfo.status
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.clearForm();
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    operationBtn() {
      let that = this;
      api.mortgageOperation(that.operationForm).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getMortgageConfig();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    editBtn(row, status) {
      if (status == "add") {
        this.dialogTitleText = "参数设置";
        this.diaStatus = "add";
        this.updateInfo = {
          status: false
        };
        this.marginFold = [];
        this.editDialog = true;
      } else {
        this.getGeneralConfigE(row.id); //编辑
      }
    },

    addSupportCoin(row) {
      this.supportDialog = true;
      this.updateInfo = JSON.parse(JSON.stringify(row));
      this.diaIndexStatus = "add";
    },

    getIndexCoinsE() {
      let that = this;
      api.getIndexCoins().then(res => {
        if (!res.code) {
          that.supportCoinArr = res.data;

        } else {
          that.$message.error(res.msg);
        }
      });
    },

    editsupportCommitBtn() {
      let that = this;
      api
        .updateIndexCoinFeeRate({
          id: that.addCoinValue.id,
          indexCoin: that.addCoinValue.indexCoin,
          openFeeRate: that.addCoinValue.openFeeRate,
          positionFeeRate: that.addCoinValue.positionFeeRate,
          closeFeeRate: that.addCoinValue.closeFeeRate
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.clearForm();
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    supportCommitBtn() {
      let that = this;
      api
        .addConfigIndexCoin({
          configId: that.updateInfo.id,
          indexCoin: that.addCoinValue.indexCoin,
          openFeeRate: that.addCoinValue.openFeeRate,
          positionFeeRate: that.addCoinValue.positionFeeRate,
          closeFeeRate: that.addCoinValue.closeFeeRate
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.clearForm();
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    getIndexCoinFeeRate(id) {
      let that = this;
      api
        .getGeneralIndexCoinConfig({
          id: id
        })
        .then(res => {
          if (!res.code) {
            that.addCoinValue = JSON.parse(JSON.stringify(res.data));
            this.supportDialog = true;
            this.diaIndexStatus = "edit";
          } else {
            that.$message.error(res.msg);
          }
        })
    },

    putawayIndexCoin(id, status) {
      let that = this;
      api
        .updateConfigIndexCoin({
          id: id,
          status: !status
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    getGeneralConfigE(id) {
      let that = this;
      api
        .getGeneralConfig({
          id: id
        })
        .then(res => {
          if (!res.code) {
            that.updateInfo = JSON.parse(JSON.stringify(res.data));
            that.marginFold = that.updateInfo.leverage;
            that.dialogTitleText = that.updateInfo.coinType + "-" + "参数设置";
            that.diaStatus = "edit";
            that.editDialog = true;
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    editCommitBtn() {
      let that = this;
      let postData = JSON.parse(JSON.stringify(this.updateInfo));
      postData.leverage = JSON.stringify(that.marginFold);
      postData.projectUserId = postData.userId;
      api.generalUpdagteConfig(postData).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getPageListInfo();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    addCommitBtn() {
      let that = this;
      let postData = JSON.parse(JSON.stringify(this.updateInfo));
      postData.leverage = JSON.stringify(that.marginFold);
      postData.projectUserId = postData.userId;
      api.generalAddConfig(postData).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getPageListInfo();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    toGoManage2(row) {
      this.$router.push("/home/finance/manage/mortgage/partnerManage2?configId=" + row.id + "&coinType=" + row.coinType);
    },

    business(id, canOpen) {
      let that = this;
      api
        .updateConfigOpen({
          id: id,
          canOpen: !canOpen
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    checkUpOrDown(id, status) {
      let that = this;
      api
        .updateCoinConfigStatus({
          id: id,
          status: !status
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    popconfirm(id, status) {
      let that = this;
      this.$confirm("您确定要切换上下架状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.checkUpOrDown(id, status);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消此操作"
          });
        });
    },

    popconfirm2(id, canOpen) {
      let that = this;
      this.$confirm("您确定要切换交易状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.business(id, canOpen);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消此操作"
          });
        });
    }
  },
  created() {},
  mounted() {
    this.getIndexCoinsE();
    this.getPageListInfo();
  }
};
</script>

<style lang="less">
.superContract-partnerManage-page {
  width: 100%;
  height: 500px;
  .greyCol {
    color: #cccccc;
  }
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    .inputWithSelectBox {
      width: 500px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
        .indexCoinClome {
          .greyCol {
            color: #cccccc;
          }

          .el-button--text {
            padding-left: 30px;
            label {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-ui5-dialog {
    .el-dialog {
      width: 40%;
      .el-dialog__header {
        text-align: center;
        color: red;
      }
      .el-dialog__body {
        .titleStrong {
          font-size: 18px;
          font-weight: bold;
        }

        .el-form {
          .setSmallInput {
            .el-form-item__label {
              width: 170px !important;
            }
            .el-form-item__content {
              margin-left: 170px !important;
              display: flex;
              justify-content: space-between;
              .el-input {
                padding-right: 12px;
                text-align: center;
                .el-input-group__append {
                  padding: 0 6px;
                }
              }
              .divText {
                width: 200px;
                text-align: center;
                padding: 0 20px;
              }
            }
          }
        }

        .fenFiveInput {
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
